export const iconFontAwesomeAnimalsMosquito = (
	<i className="fa-solid fa-mosquito"></i>
);
